

const es = {
    // Header
    header: {
        home: 'Inicio',
        whoWeAre: 'Quienes Somos',
        studentsAndGraduates: 'Estudiantes y Egresados',
        careerCounseling: 'Asesoría Laboral',
        searchVacancy: 'Buscar Vacante',
        login: 'Acceder',
        register: 'Registrarse',
        profile: 'Perfil',
        logout: 'Cerrar Sesión',
    },
    // Homepage
    home: {
        connectNow: '¡CONECTATE AHORA MISMO!',
        connectSubtitle: 'Únete a nuestra plataforma y encuentra las mejores oportunidades laborales o el talento que tu empresa necesita.',
        lookingForJob: '¿Buscas Empleo?',
        lookingForJobDesc: 'Encuentra tu trabajo ideal entre miles de vacantes disponibles',
        searchJobs: 'Buscar Empleos',
        areYouCompany: '¿Eres Empresa?',
        areYouCompanyDesc: 'Publica tus vacantes y encuentra el talento perfecto',
        postVacancy: 'Publicar Vacante',
        lastVacancy: 'Vacantes Recientes',
        popularCategories: 'Categorías Populares',
        categoriesSubtitle: '20+ Categorías de vacantes esperando por ti',
        publishedVacancies: 'Vacantes Publicadas',
        publishedTasks: 'Tareas Publicadas',
        freelancers: 'Freelancers',
        findTheRightSolution: 'Encuentre la Solución Correcta',
        heroSubtitle: 'El vínculo entre PROFESIONAL/ESTUDIANTE – EMPRESA, preparando y entregando al profesional que busca la empresa de hoy.',
        institutions: 'Instituciones',
        institutionsCountLabel: 'Número de instituciones aliadas',
        institutionsAllied: 'Instituciones aliadas',
        users: 'Usuarios',
        students: 'Estudiantes',
        graduates: 'Egresados',
        companies: 'Empresas',
        companiesCountLabel: 'Número de empresas aliadas',
        companiesAllied: 'Empresas aliadas',
    },
    // About Us
    about: {
        title: '¿Quiénes Somos?',
        subtitle: 'Conectando Talento con Oportunidades',
        description1: 'La Universidad Del Caribe, como institución de educación superior, no solo está interesada en la preparación académica de sus estudiantes; si no también, en su futuro profesional. Por esto, se creó UNIEMPLEO, como contribución al proceso de inserción laboral de nuestros estudiantes y egresados.',
        description2: 'UNIEMPLEO surge como una iniciativa de la Universidad Del Caribe para brindar a sus estudiantes y egresados una avanzada plataforma tecnológica de apoyo a sus metas y objetivos de empleo. De esta forma podrán acceder a la posición de trabajo que mejor les permita servir a su país.',
        mission: 'Misión',
        missionDesc: 'Introducir al sector empleador dominicano un profesional con las competencias del mañana.',
        vision: 'Visión',
        visionDesc: 'Un mundo donde el talento profesional y el sector empleador tengan el empoderamiento necesario para realizar su máximo potencial.',
        ctaTitle: '¡Impulsa tu carrera profesional!',
        ctaDesc: 'Conecta con las mejores oportunidades laborales del sector empleador dominicano.',
        createAccount: 'Crear una Cuenta',
    },
    // Footer
    footer: {
        rights: 'Todos los derechos reservados',
        description: 'Plataforma de empleos y pasantías de la Universidad del Caribe. Conectando talento con oportunidades laborales.',
        usefulLinks: 'Enlaces útiles',
        privacyPolicy: 'Política de Privacidad',
        cookiesPolicy: 'Política de Cookies',
        termsAndConditions: 'Términos y Condiciones',
        faq: 'FAQ',
        resources: 'Recursos',
        helpDesk: 'Mesa de Ayuda Virtual',
        blackboard: 'Blackboard',
        mail: 'Correo',
        conecta: 'Conecta',
        consult: 'Consulta',
        academicOffer: 'Oferta Académica',
        academicCalendar: 'Calendario Académico',
        unicaribeno: 'Diario UNICARIBEÑO',
        academicRequests: 'Solicitudes Académicas',
        contact: 'Contacto',
        emailContact: 'uniempleo@unicaribe.edu.do',
        phoneContact: '(809) 616-1616 Ext. 705',
        addressContact: 'Autopista 30 de mayo, Urbanización Tropical. Santo Domingo, República Dominicana.',
        followUs: 'Síguenos',
        facebook: 'Facebook',
        instagram: 'Instagram',
        linkedin: 'LinkedIn',
    },
    
    // Estudiantes y Egresados
    students: {
        title: 'Estudiantes y Egresados',
        subtitle: 'Le brindamos mayores oportunidades a los estudiantes de UNICARIBE para integrarse al campo laboral y poner en práctica todos sus conocimientos y talentos.',
        graduatesDesc1: 'Los egresados que quieran mejorar sus condiciones de trabajo, UNIEMPLEO les ayudará a encontrar la posición laboral deseada, conectándolos con empresas aliadas que valoran su formación y experiencia.',
        graduatesDesc2: 'Para los programas de pasantía que deben realizar los estudiantes de UNICARIBE, UNIEMPLEO será el vehículo mediante el cual encontrarán la empresa afiliada de su preferencia y podrán dar sus primeros pasos en el mundo profesional.',
        graduatesHighlight: 'Ya seas estudiante activo, egresado, profesional o emprendedor, nuestra plataforma está diseñada para acompañarte en cada etapa de tu desarrollo profesional.',
        ctaCard: 'Construye tu futuro profesional',
        ctaCardDesc: 'Elige cómo deseas registrarte en la plataforma y da el siguiente paso en tu carrera profesional.',
        loginAsStudent: 'Acceder como estudiante/egresado',
        comingSoon: 'Próximamente podrás completar tu formulario de registro según tu perfil.',
        platformTitle: 'Una plataforma para cada etapa',
        platformSubtitle: 'UNIEMPLEO conecta a estudiantes, egresados y empresas, facilitando la inserción laboral, el crecimiento profesional y la realización de pasantías de alto impacto.',
        forStudents: 'Para Estudiantes',
        forStudentsDesc: 'Acceso a oportunidades de pasantías y primeros empleos para comenzar tu trayectoria profesional con el respaldo de UNICARIBE.',
        forGraduates: 'Para Egresados',
        forGraduatesDesc: 'Apoyo para encontrar posiciones que se ajusten a tu perfil, experiencia y metas de crecimiento profesional.',
        forInternships: 'Pasantías y Prácticas',
        forInternshipsDesc: 'Conexión directa con empresas afiliadas para que puedas cumplir tus programas de pasantía y adquirir experiencia real.',
        ctaTitle: '¿Listo para dar el siguiente paso?',
        ctaDesc: 'Regístrate ahora y comienza a construir tu futuro profesional con UNIEMPLEO. Tu próxima oportunidad te está esperando.',
    },
    // Asesoría Laboral
    career: {
        title: 'Asesoría Laboral',
        sectionTitle: 'Asesoramiento Laboral',
        desc1: 'La Universidad del Caribe, interesada en que sus estudiantes estén orientados en los cambios y perspectivas del ámbito laboral, ofrece asesoramiento desde sus áreas disciplinares.',
        desc2: 'A continuación encontrarás el horario que te corresponde y la información de contacto de nuestros asesores especializados.',
        advisors: 'Asesores',
        specializedProfessionals: 'Profesionales especializados',
        flexibleHours: 'Horarios Flexibles',
        flexibleHoursDesc: 'Consulta según tu disponibilidad',
        specializedGuidance: 'Orientación Especializada',
        specializedGuidanceDesc: 'Desde todas las áreas disciplinares',
        personalAttention: 'Atención Personalizada',
        personalAttentionDesc: 'Contacto directo con asesores',
        ourAdvisors: 'Nuestros Asesores',
        ourAdvisorsDesc: 'Conoce a nuestro equipo de profesionales especializados en orientación laboral y desarrollo profesional.',
    },
    // Banner principal
    banner: {
        title1: 'UNIEMPLEO',
        title2: 'El vínculo entre',
        title3: 'Estudiante/Profesional - Empresa',
        subtitle: 'Conecta tu talento con las mejores oportunidades laborales del ecosistema universitario y empresarial de hoy.',
        searchJobs: 'Buscar Empleos',
        joinNow: 'Unirme Ahora',
    },

    // Contact
    contact: {
        title: 'Contacto',
        subtitle: '¿Tienes alguna pregunta, sugerencia o necesitas ayuda? ¡Contáctanos!',
        name: 'Nombre',
        email: 'Correo electrónico',
        message: 'Mensaje',
        send: 'Enviar',
    },

    // job section
    jobsection: {
        recentVacancies: 'Vacantes Recientes',
        browseAllVacancies: 'Buscar todas las vacantes',
        loadingVacancies: 'Cargando vacantes...',
        loading: 'Cargando...',
        searchTitle: 'Búsqueda de vacantes',
        resultSingular: 'Vacante encontrada',
        resultPlural: 'Vacantes encontradas',
        sortBy: 'Ordenar por:',
        sortMostRecent: 'Más recientes',
        sortOldest: 'Más antiguas',
        sortTitleAsc: 'Título (A-Z)',
        sortTitleDesc: 'Título (Z-A)',
        noVacanciesWithFilters: 'No se encontraron vacantes con los filtros seleccionados.',
        tryAdjustFilters: 'Intenta ajustar tus criterios de búsqueda.',
        expired: 'Vencida',
        previous: 'Anterior',
        next: 'Siguiente',
        noDate: 'Fecha no disponible',
        salaryFrom: 'Desde RD$',
        salaryTo: 'Hasta RD$',
        errorLoadingSelectors: 'Error al cargar los selectores. Por favor, recarga la página.',
        noVacancies: 'No hay vacantes disponibles.',
        errorLoadingVacancies: 'Error al cargar vacantes',
        noTitle: 'Sin título',
        noCity: 'Ciudad no especificada',
        noCountry: 'País',
        noContractType: 'Tipo de Contrato',
        publishedAgo: 'Publicado hace',
        day: 'día',
        hour: 'hora',
        minute: 'minuto',
        second: 'segundo',
        noJobType: 'Tipo de trabajo no especificado',
        noSalary: 'Salario no especificado',
        // Filtros / Sidebar
        filterBy: 'Filtrado por',
        resetAll: 'Reiniciar todo',
        workType: 'Tipo de Trabajo',
        modalidadLabel: 'Modalidad de Trabajo',
        tipoTrabajoLabel: 'Tipo de Trabajo',
        tipoContratoLabel: 'Tipo de Contrato',
        allModalities: 'Todas las modalidades',
        allTypes: 'Todos los tipos',
        allContracts: 'Todos los contratos',
        experienceCategory: 'Experiencia & Categoría',
        experienceLabel: 'Experiencia',
        anyExperience: 'Cualquier experiencia',
        categoryLabel: 'Categoría',
        allCategories: 'Todas las categorías',
        tagsLabel: 'Tags',
        tagsPlaceholder: 'html, css, javascript',
        tagsHelp: 'Tags separados por comas. La vacante debe contener todos los tags especificados.',
        compensation: 'Compensación',
        minSalaryLabel: 'Salario Mínimo',
        maxSalaryLabel: 'Salario Máximo',
        location: 'Ubicación',
        countryLabel: 'País',
        cityLabel: 'Ciudad',
        allCountries: 'Todos los países',
        allCities: 'Todas las ciudades',
        firstSelectCountry: 'Primero seleccione un país',
        additionalRequirements: 'Requisitos Adicionales',
        englishRequired: 'Inglés Requerido',
        searchInputLabel: 'Título de la vacante, palabras clave o frase',
        searchButton: 'Buscar',
    },
    
    // Language switcher
    lang: {
        switchTo: 'English',
        flag: '🇺🇸',
    },
};

export default es;
